/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse(value) {
    if (!('DownloadUri' in value) || value['DownloadUri'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseFromJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DownloadUri': json['DownloadUri'],
    };
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseToJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DownloadUri': value['DownloadUri'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse.js.map